export const dimensionPageSize = 100000;
//# sourceMappingURL=page-size.js.map